import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {NgbActiveModal, NgbCalendar, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {ZkUser} from '../../../classes/zk/ZkUser';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ZkPrivilege} from '../../../classes/zk/ZkPrivilege';
import {ZkUserGroup} from '../../../classes/zk/ZkUserGroup';
import {LanguageService} from '../../../services/language.service';

@Component({
  selector: 'app-zk-user-edit',
  styleUrls: ['./zk-user-edit.component.scss'],
  templateUrl: './zk-user-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ZkUserEditComponent implements OnInit {

  @Input() user: ZkUser;

  destroy = new Subject<any>();
  public currentDialog = null;
  public errorMessage: string;
  public groups = [];
  public privileges = [];
  public minDate: NgbDateStruct;

  public userForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private ngbCalendar: NgbCalendar,
              public languageService: LanguageService) {}

  ngOnInit(): void {

    this.groups = Object.keys(ZkUserGroup);
    this.privileges = Object.keys(ZkPrivilege);

    this.minDate = this.ngbCalendar.getToday();

    if (this.user) {
      this.userForm = this.formBuilder.group({
        id: [this.user.id],
        name: [this.user.name, Validators.required],
        group: [this.user.group, Validators.required],
        cardNumber: [this.user.cardNumber],
        badgeNumber: [this.user.badgeNumber, Validators.required],
        pinCode: [this.user.pinCode, Validators.required],
        validPeriod: [!!(this.user.startDate && this.user.endDate)],
        startDate: [{value: this.convertDate(this.user.startDate ? new Date(this.user.startDate) : null), disabled: !this.user.startDate}],
        endDate: [{value: this.convertDate(this.user.endDate ? new Date(this.user.endDate) : null), disabled: !this.user.endDate}],
        privilege: [this.user.privilege, Validators.required],
        disabled: [this.user.disabled, Validators.required]
      });
    } else {
      this.userForm = this.formBuilder.group({
        id: [''],
        name: ['', Validators.required],
        group: [ZkUserGroup.NONE, Validators.required],
        cardNumber: [''],
        badgeNumber: ['', Validators.required],
        pinCode: ['', Validators.required],
        validPeriod: [false],
        startDate: [{value: null, disabled: true}],
        endDate: [{value: null, disabled: true}],
        privilege: [ZkPrivilege.PERSONNEL, Validators.required],
        disabled: [false, Validators.required]
      });
    }

    this.userForm.controls.validPeriod.valueChanges.subscribe((value) => {
      if (value) {
        this.userForm.controls.startDate.enable();
        this.userForm.controls.endDate.enable();
      } else {
        this.userForm.controls.startDate.disable();
        this.userForm.controls.endDate.disable();
      }
    });
  }

  convertDate(date: Date): NgbDateStruct {
    return date ? {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    } : null;
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
